// Joya Headquarter — management views (overview, workspace, sales, ask). Hebrew.
// Same keys as mgmt.en.js.
export default {
  'joya.ov.title': 'סקירת הרשת',
  'joya.ov.sub': '7 הימים האחרונים',
  'joya.ov.chainTotals': 'כל הרשת',
  'joya.ov.revenue': 'מכירות',
  'joya.ov.checks': 'חשבונות',
  'joya.ov.diners': 'סועדים',
  'joya.ov.avgCheck': 'ממוצע לחשבון',
  'joya.ov.revenueChange': 'שינוי במכירות',
  'joya.ov.moreVisits': 'יותר ביקורים',
  'joya.ov.fewerVisits': 'פחות ביקורים',
  'joya.ov.higherSpend': 'הוצאה גבוהה יותר לחשבון',
  'joya.ov.lowerSpend': 'הוצאה נמוכה יותר לחשבון',
  'joya.ov.checksWord': 'בחשבונות',
  'joya.ov.and': 'וגם',
  'joya.ov.noCompare': 'אין מספיק נתונים להשוואה לשבוע הקודם.',
  'joya.ov.daysMissing_one': 'יום אחד בלי נתוני קופה — לא נספר כאפס.',
  'joya.ov.daysMissing_other': '{count} ימים בלי נתוני קופה — לא נספרים כאפס.',
  'joya.ov.chainMissing_one': 'ברשת חסר יום אחד של נתוני קופה — הסכום לא כולל אותו.',
  'joya.ov.chainMissing_other': 'ברשת חסרים {count} ימי סניף של נתוני קופה — הסכום לא כולל אותם.',
  'joya.ov.anomalies_one': 'יום חריג אחד בשבועיים האחרונים.',
  'joya.ov.anomalies_other': '{count} ימים חריגים בשבועיים האחרונים.',
  'joya.ov.see': 'הצגה',
  'joya.ov.dataAlerts': 'התראות נתונים',
  'joya.ov.p.draftLists': 'רשימות הזמנה בטיוטה',
  'joya.ov.p.approvedNotOrdered': 'אושרו ולא הוזמנו',
  'joya.ov.p.draftPlans': 'סידורי משמרות בטיוטה',
  'joya.ov.p.openPayrollIssues': 'בעיות שכר פתוחות',
  'joya.ov.p.shortages7d': 'חוסרים (7 ימים)',
  'joya.ov.pendingTitle': 'ממתין להחלטה',
  'joya.ov.noPending': 'אין כרגע דבר שממתין להחלטה.',
  'joya.ov.ex1': 'באיזה סניף המכירות ירדו הכי הרבה בשבוע שעבר, ולמה?',
  'joya.ov.ex2': 'השוו את אחוז עלות העבודה בין הסניפים בחודש שעבר',

  'joya.ws.title': 'סביבת העבודה של הסניף',
  'joya.ws.orderTitle': 'רשימת ההזמנה של היום',
  'joya.ws.orderReady_one': 'יש רשימה עם פריט אחד. בדקו, ערכו ואשרו.',
  'joya.ws.orderReady_other': 'יש רשימה עם {count} פריטים. בדקו, ערכו ואשרו.',
  'joya.ws.noOrderToday': 'עוד אין רשימת הזמנה להיום.',
  'joya.ws.generateList': 'הכנת הצעה להזמנה',
  'joya.ws.openList': 'פתיחת הרשימה',
  'joya.ws.otherDrafts_one': 'טיוטה אחת נוספת',
  'joya.ws.otherDrafts_other': '{count} טיוטות נוספות',
  'joya.ws.shortageTitle': 'דיווח מהיר על חוסר',
  'joya.ws.shortageItem': 'מה חסר?',
  'joya.ws.shortagePh': 'למשל: גבינת פטה',
  'joya.ws.shortageSend': 'דיווח',
  'joya.ws.shortageSaved': 'הדיווח נשמר.',
  'joya.ws.shortageSavedText': 'הדיווח נשמר, אבל הפריט לא נמצא ברשימת הרכיבים — הוא נשמר כטקסט.',
  'joya.ws.shortages7d': 'חוסרים ב-7 הימים האחרונים',
  'joya.ws.seeAll': 'הכול',
  'joya.ws.shiftsTitle': 'משמרות לשבוע הבא',
  'joya.ws.weekOf': 'השבוע שמתחיל ב-',
  'joya.ws.people_one': 'עובד אחד בסך הכול בהצעה.',
  'joya.ws.people_other': '{count} שיבוצים בסך הכול בהצעה.',
  'joya.ws.openPlan': 'פתיחת הסידור',
  'joya.ws.proposePlan': 'הכנת הצעה לשבוע',
  'joya.ws.salesTitle': 'המכירות של אתמול',
  'joya.ws.vsDayBefore': 'לעומת שלשום',
  'joya.ws.noSalesYesterday': 'אין עדיין נתוני קופה לאתמול.',
  'joya.ws.payrollTitle': 'בדיקות הכנת שכר',
  'joya.ws.payrollOpen': 'בעיות פתוחות',
  'joya.ws.payrollHint': 'החתמות חסרות, כפילויות ופערים. האישור הסופי של השכר נשאר אצלכם.',
  'joya.ws.ex1': 'כמה סועדים היו לנו אתמול בערב לעומת השבוע שעבר?',
  'joya.ws.ex2': 'אילו מנות נמכרו יותר השבוע?',
  'joya.ws.ex3': 'מה חסר בנתונים של הסניף?',

  'joya.sales.title': 'מכירות וביצועים',
  'joya.sales.sub': 'מנתוני קופת Beecomm, שנקראים מ-Allegro. יום בלי נתונים מסומן כחסר, לא כאפס.',
  'joya.sales.last7': '7 ימים',
  'joya.sales.last28': '28 ימים',
  'joya.sales.tabSummary': 'סיכום',
  'joya.sales.tabDaily': 'לפי יום',
  'joya.sales.tabShifts': 'לפי משמרת',
  'joya.sales.tabDishes': 'לפי מנה',
  'joya.sales.tabAnomalies': 'ימים חריגים',
  'joya.sales.prevRevenue': 'מכירות בתקופה הקודמת',
  'joya.sales.avgDiner': 'ממוצע לסועד',
  'joya.sales.avgDinerUnknown': 'חסר מספר סועדים בחלק גדול מהחשבונות',
  'joya.sales.volumeEffect': 'השפעת כמות הביקורים',
  'joya.sales.spendEffect': 'השפעת ההוצאה לחשבון',
  'joya.sales.formulaHelp': 'C = מספר חשבונות, A = ממוצע לחשבון. שני החלקים יחד שווים לשינוי במכירות.',
  'joya.sales.coverage': 'ימים עם נתונים',
  'joya.sales.legendRevenue': 'מכירות',
  'joya.sales.legendMissing': 'אין נתונים — לא אפס',
  'joya.sales.noData': 'אין נתונים',
  'joya.sales.checksShort': 'חשבונות',
  'joya.sales.dinersShort': 'סועדים',
  'joya.sales.noShifts': 'לא הוגדרו משמרות לסניף.',
  'joya.sales.outside': 'מחוץ לשעות המשמרות',
  'joya.sales.prevShort': 'קודם:',
  'joya.sales.notOnMenu': 'לא בתפריט',
  'joya.sales.units': 'יחידות',
  'joya.sales.unitsChange': 'שינוי ביחידות',
  'joya.sales.noPrev': 'אין מכירות בתקופה הקודמת להשוואה',
  'joya.sales.method': 'שיטה',
  'joya.sales.noAnomalies': 'לא נמצאו ימים חריגים בתקופה.',
  'joya.sales.actual': 'בפועל',
  'joya.sales.expected': 'צפוי (חציון)',
  'joya.sales.basis': 'לעומת אותו יום בשבוע ב-{weeks} השבועות הקודמים.',
  'joya.sales.missingTitle': 'ימים בלי נתוני קופה',
  'joya.sales.missingHelp': 'לימים האלה אין נתוני Beecomm ב-Allegro — הם לא נספרים כאפס.',



  'joya.askPage.title': 'שאלו את המטה',
  'joya.askPage.howTitle': 'איך נוצרת תשובה',
  'joya.askPage.how1': 'אתם שואלים במילים, בעברית או באנגלית.',
  'joya.askPage.how2': 'המערכת מריצה חישובים על הנתונים שלכם, רק על סניפים ונתונים שמותר לכם לראות.',
  'joya.askPage.how3': 'מודל השפה כותב את המילים בלבד. כל המספרים באים מהחישובים, לא ממנו.',
  'joya.askPage.how4': 'מתחת לכל תשובה מופיעים החישובים, עם התקופה ומקור הנתונים.',
  'joya.askPage.how5': 'מספר בתשובה שלא נמצא בחישובים מסומן באזהרה, כדי שתבדקו אותו.',
  'joya.askPage.scope': 'השאלות מתייחסות לסניף שבחרתם בראש העמוד (או לכל הסניפים שלכם).',
  'joya.askPage.ex1': 'מה היו המכירות בשבוע שעבר לעומת השבוע שלפניו?',
  'joya.askPage.ex2': 'אילו מנות גדלו הכי הרבה החודש?',
  'joya.askPage.ex3': 'מה היה אחוז עלות העבודה בחודש שעבר?',
  'joya.askPage.ex4': 'כמה מכרנו לכל שעת עבודה בשבוע שעבר?',
  'joya.askPage.ex5': 'אילו נתונים חסרים או לא מעודכנים?',
  'joya.askPage.ex6': 'הראו את הביקוש בימי חמישי האחרונים',
};
